export default {
    EN : {
        "site.name": "Online Store",
        "cart.total" : "Total",
        "cart.title" : "Cart",
        "cart.message": "Nothing is here yet",
        "item.addBtn" : "Add to cart",
        "item.moreInfo" : "More info",
        "filter.all" : "All",
        "filter.phones" : "Phones",
        "serviceText.nothingFound": "Nothing Found",
    },
    RU : {
        "site.name" : "Онлайн-магазин",
        "cart.total" : "Итого",
        "cart.title" : "Корзина",
        "cart.message": "Здесь пока ничего нет",
        "item.addBtn" : "Добавить",
        "item.moreInfo" : "Детальнее",
        "filter.all" : "Все",
        "filter.phones" : "Смартфоны",
        "serviceText.nothingFound": "Ничего не найдено",
    }
}


// WEBPACK FOOTER //
// ./src/messages.js